<div role="radiogroup" aria-labelledby="question_label">
  <div class="row">
    <p class="question_text {{text_class}}" id="question_label">
      {{text}}
    </p>
    {{#if subtext}}
    <div class="subtext {{subtext_class}}">{{subtext}}</div>
    {{/if}}
  </div>
  <div class="row">
    {{#if image_path}}
    <div class="question_image">
      <img src="{{assetPath image_path}}" />
    </div>
    {{/if}}
    <div class="question_block" data-toggle="buttons" id="question_{{id}}">
      <fieldset>
        <div role="{{#if (equal ../response_type 'multiple_selection')}}group{{else}}radiogroup{{/if}}">
          {{#each answers}}
          <div
            class="assessment_answer {{#if (equal ../response_type 'multiple_selection')}}checkbox{{else}}radio{{/if}}"
            aria-checked="false" role="{{#if (equal ../response_type 'multiple_selection')}}checkbox{{else}}radio{{/if}}" tabindex="0">
            {{#if badge_class}}
            <div class="{{badge_class}}">{{badge_value}}</div>
            {{/if}}
            {{#if media}}
            <div class="answer_image">
              <img src="{{assetPath media}}" />
            </div>
            {{/if}}
            <input aria-labelledby="question_label" tabindex="-1" aria-hidden="true"
              type="{{#if (equal ../response_type 'multiple_selection')}}checkbox{{else}}radio{{/if}}"
              role="{{#if (equal ../response_type 'multiple_selection')}}checkbox{{else}}radio{{/if}}" id="{{id}}"
              name="question_{{../id}}" data-question-id="{{../id}}" value="{{id}}" />
            <label id="answer_id_{{id}}" class="answer_text {{text_class}}">{{text}}</label>
          </div>
          {{/each}}
        </div>
      </fieldset>
    </div>
    {{#compare (equal response_type 'multiple_selection') '||' submit_button}}
    <button class="btn btn-primary" type="button" id="button_{{id}}" disabled>{{t 'submitbtn'}}</button>
    {{else}}
    {{/compare}}
  </div>
</div>
